$(function(){
  //$('.references').references();
})

+function($){
  $.fn.references = function(){
    return this.each(function(){
      var ref = $(this);
      var btnLeft = $('.reference-left', ref);
      var btnRight = $('.reference-right', ref);
      var currentReference = 0;
      var autoSwitchInterval = 10; //seconds
      var delay = 0;

      var references = [];
      $('.hidden-references .ref').each(function(){
        references.push({
          name: $(this).find('.name').text(),
          pos: $(this).find('.pos').text(),
          www: $(this).find('.www').length > 0 ? $(this).find('.www').text() : '',
          text: $(this).find('.text').text(),
          img: $(this).find('img').length > 0 ? $(this).find('img') : $('<div>').addClass('gray-circle')
        });
      });

      var changeReference = function(offset){
        currentReference += offset;
        if(currentReference < 0) currentReference = references.length - 1;
        if(currentReference >= references.length) currentReference = 0;

        ref.addClass('hide-reference')
        setTimeout(function(){
          var newRef = references[currentReference]
          ref.find('.ref-name').text(newRef.name);
          ref.find('.ref-pos').text(newRef.pos);
          ref.find('.ref-www').html('<a href="http://' + newRef.www + '" target="_blank">' + newRef.www + '</a>');
          ref.find('.ref-text').text(newRef.text);
          var pill = ref.find('.ref-header-image img').length > 0 ? ref.find('.ref-header-image img') : ref.find('.ref-header-image .gray-circle');
          pill.replaceWith(newRef.img.clone());
          ref.removeClass('hide-reference');
        },300);
      }

      var autoSwitchFunction = function(){
        if(delay > 0){
          setTimeout(autoSwitchFunction, delay);
          delay = 0;
          return;
        }

        changeReference(1);
        setTimeout(autoSwitchFunction, autoSwitchInterval * 1000);
      }

      btnLeft.click(function(){delay = 1500; changeReference(-1);});
      btnRight.click(function(){delay = 1500; changeReference(1);});
      setTimeout(autoSwitchFunction, autoSwitchInterval * 1000);
    });
  }
}(jQuery)



/*$(function(){
  var reference = new TReference();
  reference.init();
});

function TReference() {
  this.autoSwitchInterval = 10;   // seconds
  this.referenceTimer;
  this.currentReference = 1;
  this.referencesCount;
  
  this.init = function() {
    this.referencesCount = $('.reference').length;
    this.activeReference(this.currentReference);
    this.setReferenceTimer();  
    this.bindClicks();
  }

  this.activeReference = function(referenceToShow) {
    this.currentReference = referenceToShow;
    this.resetReferenceTimer();

    $('.reference').fadeOut(300);
    $('#reference' + this.currentReference).fadeIn(300);
  }

  this.bindClicks = function() {
    var that = this;

    $('.reference-right').on("click", function() {
        that.activeReference(that.getNextReferenceNumber());
    });

    $('.reference-left').on("click", function() {
        if (that.currentReference == 1) {
            that.currentReference = that.referencesCount;
            that.activeReference(that.currentReference);
            return;
        }
        if (that.currentReference > 1) {
            that.currentReference = that.currentReference - 1;
            that.activeReference(that.currentReference);
            return;
        }
    });
  }

  this.getNextReferenceNumber = function() {
    return (this.currentReference % this.referencesCount) + 1;
  }

  this.getPrevReferenceNumber = function() {
    var t = ((this.currentReference - 1) % this.referencesCount);
    if (t == 0) t = this.referencesCount;
    return t;
  }

  this.setReferenceTimer = function() {
    var that = this;
    
    this.referenceTimer = setTimeout(
            function() { that.activeReference(that.getNextReferenceNumber()) }, 
            that.autoSwitchInterval * 1000
          );
  }

  this.resetReferenceTimer = function() {
    clearInterval(this.referenceTimer);
    this.setReferenceTimer();
  }
}*/